module.exports = __webpack_public_path__ + "img/treeplant3_7-8-2021.080320cd.jpg";